export type JSONLD = Record<string, unknown>;

export const jsonLdPublisher = {
  "@type": "Organization",
  name: "Gromia",
  url: "https://www.gromia.com",
  logo: {
    "@type": "ImageObject",
    url: "https://www.gromia.com/logos/logo.svg",
    width: "763.109",
    height: "177.035",
  },
};

export function genericJsonLd(title: string, description?: string): JSONLD {
  return {
    "@context": "http://schema.org",
    "@type": "WebPage",
    name: title,
    description: description,
    publisher: jsonLdPublisher,
  };
}
